module.exports = __webpack_public_path__ + "img/kid-a.c49b38ec.svg";